<template>
  <el-dialog
    ref="wDialogRef"
    class="w_dialog"
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="提现设置"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleDialogClosed"
  >
    <!-- <el-checkbox v-model="checked" @change="openAuto"
      >是否开启自动提现</el-checkbox
    > -->
    <div v-if="disabledSetWithdraw" style="margin-top: 20px">
      <el-form
        v-if="detailInfo.douGongWithdrawCardType == 0"
        :model="detailInfo.douGongInfo"
        label-width="auto"
        disabled
      >
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="企业名称" prop="regName">
              <el-input
                v-model="detailInfo.douGongInfo.regName"
                :maxlength="128"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="法人姓名" prop="legalName">
              <el-input
                v-model="detailInfo.douGongInfo.legalName"
                placeholder="请输入证件号码对应的姓名"
                :maxlength="32"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="法人证件号码" prop="legalCertNo">
              <el-input
                v-model="detailInfo.douGongInfo.legalCertNo"
                placeholder="请输入"
                :maxlength="18"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="银行卡号" prop="cardNo">
              <el-input
                v-model="detailInfo.douGongInfo.cardNo"
                :maxlength="32"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        v-if="detailInfo.douGongWithdrawCardType == 1"
        :model="detailInfo.douGongInfo"
        label-width="auto"
        disabled
      >
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="个人姓名" prop="name">
              <el-input
                v-model="detailInfo.douGongInfo.name"
                placeholder="请输入证件上的姓名"
                :maxlength="32"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="个人证件号码" prop="certNo">
              <el-input
                v-model="detailInfo.douGongInfo.certNo"
                placeholder="请输入"
                :maxlength="18"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="银行卡号" prop="cardNo">
              <el-input
                v-model="detailInfo.douGongInfo.cardNo"
                :maxlength="32"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24"> </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-else style="margin-top: 20px">
      <div class="withdraw_type">
        <el-radio v-model="userType" label="1" border>企业用户</el-radio>
        <el-radio v-model="userType" label="2" border>个人用户</el-radio>
      </div>
      <el-form
        v-show="userType == '1'"
        ref="params"
        :model="params"
        :rules="paramsRules"
        label-width="auto"
        :disabled="disabledSetWithdraw"
      >
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="营业执照" prop="businessLicense">
              <el-upload
                action="#"
                :show-file-list="false"
                :http-request="handleImgSuccess"
                :data="{ key: 'businessLicense' }"
              >
                <img
                  v-if="params.businessLicense"
                  :src="params.businessLicense"
                  class="car_upload_img"
                />
                <div v-else class="car_uploader_icon">
                  <i class="el-icon-plus"></i>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="企业名称" prop="regName">
              <el-input
                v-model="params.regName"
                :maxlength="128"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="统一社会信用代码" prop="licenseCode">
              <el-input
                v-model="params.licenseCode"
                :maxlength="18"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="证照有效期类型" prop="licenseValidityType">
              <el-select
                v-model="params.licenseValidityType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in certValidityTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="证照起始有效期" prop="licenseBeginDate">
              <el-date-picker
                v-model="params.licenseBeginDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item
              v-if="params.licenseValidityType == '0'"
              label="证照结束有效期"
              prop="licenseEndDate"
            >
              <el-date-picker
                v-model="params.licenseEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                :picker-options="licenseEndDatePickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="注册地址" prop="regProvId">
              <el-cascader
                v-model="address"
                :options="regionData"
                size="large"
                @change="addressChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="注册详细地址" prop="regDetail">
              <el-input
                v-model="params.regDetail"
                placeholder="请输入"
                :maxlength="255"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="12" :xs="24">
            <el-form-item
              label="法人身份证人像面"
              prop="corporateFrontDocument"
            >
              <el-upload
                action="#"
                :show-file-list="false"
                :http-request="handleImgSuccess"
                :data="{ key: 'corporateFrontDocument' }"
              >
                <img
                  v-if="params.corporateFrontDocument"
                  :src="params.corporateFrontDocument"
                  class="car_upload_img"
                />
                <div v-else class="car_uploader_icon">
                  <i class="el-icon-plus"></i>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="法人身份证国徽面" prop="corporateBackDocument">
              <el-upload
                action="#"
                :show-file-list="false"
                :http-request="handleImgSuccess"
                :data="{ key: 'corporateBackDocument' }"
              >
                <img
                  v-if="params.corporateBackDocument"
                  :src="params.corporateBackDocument"
                  class="car_upload_img"
                />
                <div v-else class="car_uploader_icon">
                  <i class="el-icon-plus"></i>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="法人姓名" prop="legalName">
              <el-input
                v-model="params.legalName"
                placeholder="请输入证件号码对应的姓名"
                :maxlength="32"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="法人证件号码" prop="legalCertNo">
              <el-input
                v-model="params.legalCertNo"
                placeholder="请输入"
                :maxlength="18"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="证件有效期类型" prop="legalCertValidityType">
              <el-select
                v-model="params.legalCertValidityType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in certValidityTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24"> </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="证件起始有效期" prop="legalCertBeginDate">
              <el-date-picker
                v-model="params.legalCertBeginDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item
              v-if="params.legalCertValidityType == '0'"
              label="证件结束有效期"
              prop="legalCertEndDate"
            >
              <el-date-picker
                v-model="params.legalCertEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                :picker-options="legalCertEndDatePickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="联系人姓名" prop="contactName">
              <el-input
                v-model="params.contactName"
                placeholder="请输入"
                :maxlength="32"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="联系人手机号" prop="contactMobile">
              <el-input
                v-model="params.contactMobile"
                placeholder="请输入"
                :maxlength="11"
                @input="
                  () =>
                    (params.contactMobile = params.contactMobile.replace(
                      /\s+/g,
                      ''
                    ))
                "
              /> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
      <el-form
        v-show="userType == '2'"
        ref="paramsPerson"
        :model="paramsPerson"
        :rules="paramsPersonRules"
        label-width="auto"
        :disabled="disabledSetWithdraw"
      >
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="个人身份证人像面" prop="personalFrontDocument">
              <el-upload
                action="#"
                :show-file-list="false"
                :http-request="handleImgSuccess"
                :data="{ key: 'personalFrontDocument' }"
              >
                <img
                  v-if="paramsPerson.personalFrontDocument"
                  :src="paramsPerson.personalFrontDocument"
                  class="car_upload_img"
                />
                <div v-else class="car_uploader_icon">
                  <i class="el-icon-plus"></i>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="个人身份证国徽面" prop="personalBackDocument">
              <el-upload
                action="#"
                :show-file-list="false"
                :http-request="handleImgSuccess"
                :data="{ key: 'personalBackDocument' }"
              >
                <img
                  v-if="paramsPerson.personalBackDocument"
                  :src="paramsPerson.personalBackDocument"
                  class="car_upload_img"
                />
                <div v-else class="car_uploader_icon">
                  <i class="el-icon-plus"></i>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="个人姓名" prop="name">
              <el-input
                v-model="paramsPerson.name"
                placeholder="请输入证件上的姓名"
                :maxlength="32"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="个人证件号码" prop="certNo">
              <el-input
                v-model="paramsPerson.certNo"
                placeholder="请输入"
                :maxlength="18"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="证件有效期类型" prop="certValidityType">
              <el-select
                v-model="paramsPerson.certValidityType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in certValidityTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="个人证件起始有效期" prop="certBeginDate">
              <el-date-picker
                v-model="paramsPerson.certBeginDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item
              v-if="paramsPerson.certValidityType == '0'"
              label="个人证件结束有效期"
              prop="certEndDate"
            >
              <el-date-picker
                v-model="paramsPerson.certEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                :picker-options="certEndDatePickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="手机号" prop="mobileNo">
              <el-input
                v-model="paramsPerson.mobileNo"
                placeholder="请输入"
                :maxlength="11"
                @input="
                  () =>
                    (paramsPerson.mobileNo = paramsPerson.mobileNo.replace(
                      /\s+/g,
                      ''
                    ))
                "
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider>{{ userType == "1" ? "企业" : "本人" }}结算卡信息</el-divider>
      <el-form
        ref="bankCardInfoRef"
        :model="bankCardInfo"
        :rules="bankCardInfoRules"
        label-width="auto"
        :disabled="disabledSetWithdraw"
      >
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item
              v-if="userType == '1'"
              label="持卡人姓名"
              prop="cardName"
            >
              <el-input
                v-model="bankCardInfo.cardName"
                placeholder="示例:成都慧充科技有限公司"
                :maxlength="128"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="银行卡号" prop="cardNo">
              <el-input
                v-model="bankCardInfo.cardNo"
                :placeholder="userType == '1' ? '请输入' : '请输入本人银行卡号'"
                :maxlength="32"
                @input="
                  () =>
                    (bankCardInfo.cardNo = bankCardInfo.cardNo.replace(
                      /\s+/g,
                      ''
                    ))
                "
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="银行所在省市" prop="provId">
              <el-cascader
                v-model="bankAddress"
                :options="provinceAndCityData"
                size="large"
                @change="bankAddressChange"
              /> </el-form-item
          ></el-col>
          <!-- <el-col :span="12" :xs="24"> </el-col> -->
        </el-row>
        <el-row v-if="userType == '1'" :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item
              label="银行名称"
              prop="bankCode"
              :rules="[
                {
                  required: userType == '1',
                  message: '请选择银行名称',
                },
              ]"
            >
              <el-select
                v-model="bankCardInfo.bankCode"
                :placeholder="userType == '1' ? '请选择' : '非必填'"
                @change="handleBankSelectChange"
                filterable
                ref="select"
                @focus="closeReadOnly"
                @hook:mounted="closeReadOnly"
                @visible-change="closeReadOnly"
                remote
                :remote-method="remoteGetBankList"
                :loading="loading"
                reserve-keyword
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in bankList"
                  :key="item.bankId"
                  :label="item.bankName"
                  :value="item.bankId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item
              label="支行名称"
              prop="branchCode"
              :rules="[
                {
                  required: userType == '1',
                  message: '请选择支行名称',
                },
              ]"
            >
              <el-select
                v-model="bankCardInfo.branchCode"
                :placeholder="userType == '1' ? '请选择' : '非必填'"
                filterable
                ref="select"
                @focus="closeReadOnly"
                @hook:mounted="closeReadOnly"
                @visible-change="closeReadOnly"
                remote
                :remote-method="remoteGetBranchBankList"
                :loading="loading"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in branchBankList"
                  :key="item.paymentLines"
                  :label="item.bankName"
                  :value="item.paymentLines"
                >
                </el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
    </div>
    <div class="withdraw_tip" v-if="!disabledSetWithdraw">
      注：自动识别的内容可能会出现误差，请仔细检查~
    </div>
    <div slot="footer">
      <el-button @click="noDialog">取消</el-button>
      <el-button type="primary" @click="post" v-if="!disabledSetWithdraw"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { searchBankBranchList, searchBankList } from "@/api/common/bank/bank";
import convertTheDocumentToText from "@/api/common/util/convertTheDocumentToText";
import agentDisableAutoWithdrawMoney from "@/api/user/agent-manage/agentDisableAutoWithdrawMoney";
import agentEnableAutoWithdrawMoney from "@/api/user/agent-manage/agentEnableAutoWithdrawMoney";
import agentFillEnterPriseInfo from "@/api/user/agent-manage/agentFillEnterPriseInfo";
import agentFillInInformation from "@/api/user/agent-manage/agentFillInInformation";
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import { debounce } from "@/utils/utils";
import {
  CodeToText,
  provinceAndCityData,
  regionData,
} from "element-china-area-data";

export default {
  name: "withdrawSetDialog",
  mixins: [dialogMixin, resDisposeMixin],
  props: {
    autoWithdraw: Number,
    info: Object,
  },
  data() {
    return {
      disabledSetWithdraw: false,
      checked: false,
      userType: "1",
      certValidityTypeList: [
        { value: "1", label: "长期有效" },
        { value: "0", label: "非长期有效" },
      ],
      bankList: [],
      branchBankList: [],
      regionData: regionData,
      provinceAndCityData: provinceAndCityData,
      address: [],
      bankAddress: [],
      params: {
        regName: "",
        businessLicense: "",
        licenseCode: "",
        licenseValidityType: "1",
        licenseBeginDate: "",
        licenseEndDate: "",
        regProvId: "",
        regAreaId: "",
        regDistrictId: "",
        regDetail: "",
        corporateFrontDocument: "",
        corporateBackDocument: "",
        legalName: "",
        legalCertType: "00",
        legalCertNo: "",
        legalCertValidityType: "",
        legalCertBeginDate: "",
        legalCertEndDate: "",
        contactName: "",
        contactMobile: "",
      },
      paramsRules: {
        regName: [
          {
            required: true,
            message: "请输入企业名称",
          },
        ],
        businessLicense: [
          {
            required: true,
            message: "请上传营业执照",
          },
        ],
        licenseCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
          },
        ],
        licenseValidityType: [
          {
            required: true,
            message: "请选择证照有效期类型",
          },
        ],
        licenseBeginDate: [
          {
            required: true,
            message: "请选择证照起始有效期",
          },
        ],
        licenseEndDate: [
          {
            required: true,
            message: "请选择证照结束有效期",
          },
        ],
        regProvId: [
          {
            required: true,
            message: "请选择注册地址",
          },
        ],
        regDetail: [
          {
            required: true,
            message: "请输入注册详细地址",
          },
        ],
        corporateFrontDocument: [
          {
            required: true,
            message: "请上传法人身份证人像面",
          },
        ],
        corporateBackDocument: [
          {
            required: true,
            message: "请上传法人身份证国徽面",
          },
        ],
        legalName: [
          {
            required: true,
            message: "请输入法人姓名",
          },
        ],
        legalCertNo: [
          {
            required: true,
            message: "请输入法人证件号码",
          },
          {
            pattern: /^(^\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
            message: "法人证件号码格式错误",
          },
        ],
        legalCertValidityType: [
          {
            required: true,
            message: "请选择证件有效期类型",
          },
        ],
        legalCertBeginDate: [
          {
            required: true,
            message: "请选择法人证件起始有效期",
          },
        ],
        legalCertEndDate: [
          {
            required: true,
            message: "请选择法人证件结束有效期",
          },
        ],
        contactName: [
          {
            required: true,
            message: "请输入联系人姓名",
          },
        ],
        contactMobile: [
          {
            required: true,
            message: "请输入联系人手机号",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "联系人手机号格式错误",
          },
        ],
      },

      paramsPerson: {
        personalFrontDocument: "",
        personalBackDocument: "",
        name: "",
        certType: "00",
        certNo: "",
        certValidityType: "",
        certBeginDate: "",
        certEndDate: "",
        mobileNo: "",
      },
      paramsPersonRules: {
        personalFrontDocument: [
          {
            required: true,
            message: "请上传个人身份证人像面",
          },
        ],
        personalBackDocument: [
          {
            required: true,
            message: "请上传个人身份证国徽面",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入个人姓名",
          },
        ],
        certNo: [
          {
            required: true,
            message: "请输入个人证件号码",
          },
          {
            pattern: /^(^\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
            message: "个人证件号码格式错误",
          },
        ],
        certValidityType: [
          {
            required: true,
            message: "请选择证件有效期类型",
          },
        ],
        certBeginDate: [
          {
            required: true,
            message: "请选择个人证件起始有效期",
          },
        ],
        certEndDate: [
          {
            required: true,
            message: "请选择个人证件结束有效期",
          },
        ],
        mobileNo: [
          {
            required: true,
            message: "请输入手机号",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式错误",
          },
        ],
      },

      bankCardInfo: {
        cardType: "",
        cardName: "",
        cardNo: "",
        provId: "",
        areaId: "",
        bankCode: "",
        branchCode: "",
      },
      loading: false,
      bankCardInfoRules: {
        cardName: [
          {
            required: true,
            message: "请输入持卡人姓名",
          },
        ],
        cardNo: [
          {
            required: true,
            message: "请输入银行卡号",
          },
        ],
        provId: [
          {
            required: true,
            message: "请选择银行所在省",
          },
        ],
        areaId: [
          {
            required: true,
            message: "请选择银行所在市",
          },
        ],
      },
      detailInfo: {
        regName: "",
        legalName: "",
        legalCertNo: "",
        cardNo: "",

        name: "",
        certNo: "",
      },
      licenseEndDatePickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.params.licenseBeginDate);
        },
      },
      legalCertEndDatePickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.params.legalCertBeginDate);
        },
      },
      certEndDatePickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.paramsPerson.certBeginDate);
        },
      },
      checkEnterpriseFlag: false, // 是否已仔细检查企业用户信息
      checkPersonFlag: false, // 是否已仔细检查个人用户信息
    };
  },
  computed: {
    // 法人年龄
    legalAge() {
      return this.params.legalCertNo.substr(6, 4)
        ? new Date().getFullYear() - this.params.legalCertNo.substr(6, 4)
        : 0;
    },
    // 法人证件有效年限
    legalCertValidityYear() {
      return this.params.legalCertEndDate.substr(0, 4)
        ? this.params.legalCertEndDate.substr(0, 4) -
            this.params.legalCertBeginDate.substr(0, 4)
        : 0;
    },
    // 个人年龄
    personalAge() {
      return this.paramsPerson.certNo.substr(6, 4)
        ? new Date().getFullYear() - this.paramsPerson.certNo.substr(6, 4)
        : 0;
    },
    // 个人证件有效年限
    personalCertValidityYear() {
      return this.paramsPerson.certEndDate.substr(0, 4)
        ? this.paramsPerson.certEndDate.substr(0, 4) -
            this.paramsPerson.certBeginDate.substr(0, 4)
        : 0;
    },
  },
  watch: {
    legalAge(value) {
      // 大于46岁，且证件有效期大于等于10年则为长期有效
      if (value >= 46 && this.legalCertValidityYear >= 10)
        this.$set(this.params, "legalCertValidityType", "1");
      else this.$set(this.params, "legalCertValidityType", "0");
    },
    legalCertValidityYear(value) {
      if (value >= 10 && this.legalAge >= 46)
        this.$set(this.params, "legalCertValidityType", "1");
      else this.$set(this.params, "legalCertValidityType", "0");
    },
    personalAge(value) {
      // 大于46岁，且证件有效期大于等于10年则为长期有效
      if (value >= 46 && this.personalCertValidityYear >= 10)
        this.$set(this.paramsPerson, "certValidityType", "1");
      else this.$set(this.paramsPerson, "certValidityType", "0");
    },
    personalCertValidityYear(value) {
      if (value >= 10 && this.personalAge >= 46)
        this.$set(this.paramsPerson, "certValidityType", "1");
      else this.$set(this.paramsPerson, "certValidityType", "0");
    },
    autoWithdraw(value) {
      this.checked = value === 1;
    },
    dialog(value) {
      console.log(value);
    },
    info: {
      handler(value) {
        this.disabledSetWithdraw = !!value.douGongInfo;
        if (value) {
          this.detailInfo = { ...value };
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    remoteGetBankList: debounce(function (query) {
      if (query !== "") {
        this.loading = true;
        searchBankList({
          bank_name: query,
        }).then((res) => {
          this.loading = false;
          console.log(res, 88);
          this.bankList = res.data;
        });
      } else {
        this.bankList = [];
      }
    }, 350),
    remoteGetBranchBankList: debounce(function (query) {
      console.log(query);
      this.loading = true;
      searchBankBranchList({
        bank_name: query,
        bank_id: this.bankCardInfo.bankCode,
      }).then((res) => {
        this.loading = false;
        console.log(res, 88);
        this.branchBankList = res.data;
      });
    }, 350),
    addressChange(arr) {
      this.params.regProvId = arr[0];
      this.params.regAreaId = arr[1];
      this.params.regDistrictId = arr[2];
      console.log(CodeToText);
    },
    bankAddressChange(arr) {
      this.bankCardInfo.provId = arr[0];
      this.bankCardInfo.areaId = arr[1];
    },
    handleBankSelectChange(e) {
      console.log(e);
      this.bankCardInfo.branchCode = "";
      this.branchBankList = [];
      this.remoteGetBranchBankList("");
    },
    openAuto(newV) {
      if (newV === true) {
        agentEnableAutoWithdrawMoney().then((res) => {
          this.resDispose({
            res,
          });
        });
      } else if (newV === false) {
        agentDisableAutoWithdrawMoney().then((res) => {
          this.resDispose({
            res,
          });
        });
      }
    },
    // 照片上传成功时触发
    handleImgSuccess(event) {
      const that = this;
      const file = event.file;
      const acceptList = ["image/jpeg", "image/jpg", "image/png"];
      if (acceptList.indexOf(file.type) == -1) {
        return this.$message.error("只允许上传jpg/png图片");
      }
      if (file.size > 10000 * 1024) {
        return this.$message.error("图片大小必须小于10MB");
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");

        let img = new Image();
        img.src = reader.result;
        img.onload = function () {
          const MAX_SIZE = 800; // 设置最大尺寸
          let width = img.width;
          let height = img.height;
          // 图片大小大于最大尺寸，则按比例缩放图片
          if (width > height) {
            if (width > MAX_SIZE) {
              height *= MAX_SIZE / width;
              width = MAX_SIZE;
            }
          } else {
            if (height > MAX_SIZE) {
              width *= MAX_SIZE / height;
              height = MAX_SIZE;
            }
          }
          canvas.width = width;
          canvas.height = height;
          if (!context) {
            return;
          }
          context.drawImage(img, 0, 0, width, height);
          that[that.userType == "1" ? "params" : "paramsPerson"][
            event.data.key
          ] = canvas.toDataURL(file.type, 1);
          img = null;

          // 图片识别获取对应信息
          if (event.data.key == "businessLicense") {
            // 营业执照识别
            // 1-正面 2-反面 3-营业
            that
              .handleOcrImage(that.params[event.data.key], 3)
              .then((res) => {
                that.handleOcrResult(res, that.params, [
                  { key: "regName", rKey: "单位名称" },
                  { key: "licenseCode", rKey: "社会信用代码" },
                  { key: "licenseCode", rKey: "证件编号" },
                  // {
                  //   key: "licenseBeginDate",
                  //   rKey: "有效期起始日期",
                  //   valueCb: (v) => v.replace(/年|月/g, "-").replace("日", ""),
                  // },
                  { key: "regDetail", rKey: "地址" },
                  { key: "legalName", rKey: "法人" },
                  { key: "contactName", rKey: "法人" },
                ]);
                that.bankCardInfo.cardName = res["单位名称"].words;
                that.$message.success("营业执照识别成功~");
              })
              .catch(() => {
                that.params[event.data.key] = "";
              });
          } else if (event.data.key == "corporateFrontDocument") {
            // 法人身份证人像面识别
            that
              .handleOcrImage(that.params[event.data.key], 1)
              .then((res) => {
                console.log(res);
                that.handleOcrResult(res, that.params, [
                  { key: "legalName", rKey: "姓名" },
                  { key: "legalCertNo", rKey: "公民身份号码" },
                ]);
                that.$message.success("身份证人像面识别成功~");
              })
              .catch(() => {
                that.params[event.data.key] = "";
              });
          } else if (event.data.key == "corporateBackDocument") {
            // 法人身份证国徽面识别
            that
              .handleOcrImage(that.params[event.data.key], 2)
              .then((res) => {
                console.log(res);
                that.handleOcrResult(res, that.params, [
                  {
                    key: "legalCertBeginDate",
                    rKey: "签发日期",
                    valueCb: (v) =>
                      `${v.substr(0, 4)}-${v.substr(4, 2)}-${v.substr(-2)}`,
                  },
                  {
                    key: "legalCertEndDate",
                    rKey: "失效日期",
                    valueCb: (v) =>
                      v.includes("长期")
                        ? "2099-01-01"
                        : `${v.substr(0, 4)}-${v.substr(4, 2)}-${v.substr(-2)}`,
                  },
                ]);
                that.$message.success("身份证国徽面识别成功~");
              })
              .catch(() => {
                that.params[event.data.key] = "";
              });
          } else if (event.data.key == "personalFrontDocument") {
            // 个人身份证人像面识别
            that
              .handleOcrImage(that.paramsPerson[event.data.key], 1)
              .then((res) => {
                console.log(res);
                that.handleOcrResult(res, that.paramsPerson, [
                  { key: "name", rKey: "姓名" },
                  { key: "certNo", rKey: "公民身份号码" },
                ]);
                that.$message.success("身份证人像面识别成功~");
              })
              .catch(() => {
                that.paramsPerson[event.data.key] = "";
              });
          } else if (event.data.key == "personalBackDocument") {
            // 个人身份证国徽面识别
            that
              .handleOcrImage(that.paramsPerson[event.data.key], 2)
              .then((res) => {
                console.log(res);
                that.handleOcrResult(res, that.paramsPerson, [
                  {
                    key: "certBeginDate",
                    rKey: "签发日期",
                    valueCb: (v) =>
                      `${v.substr(0, 4)}-${v.substr(4, 2)}-${v.substr(-2)}`,
                  },
                  {
                    key: "certEndDate",
                    rKey: "失效日期",
                    valueCb: (v) =>
                      v.includes("长期")
                        ? "2099-01-01"
                        : `${v.substr(0, 4)}-${v.substr(4, 2)}-${v.substr(-2)}`,
                  },
                ]);
                that.$message.success("身份证国徽面识别成功~");
              })
              .catch(() => {
                that.paramsPerson[event.data.key] = "";
              });
          }
        };
      };
      // file -> base64
      reader.readAsDataURL(file);
    },
    // 处理文字识别后的结果
    handleOcrResult(res, form, mapList) {
      mapList.forEach((m) => {
        const valueCb = m.valueCb || (() => res[m.rKey].words);
        if (res[m.rKey] && res[m.rKey].words != "无")
          this.$set(form, m.key, valueCb(res[m.rKey].words));
        console.log(form);
      });
    },
    // 图片OCR文字识别
    handleOcrImage(file, fileType) {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      return new Promise((resolve, reject) => {
        convertTheDocumentToText({
          file,
          fileType,
        })
          .then((res) => {
            if (res.error_code) {
              console.log(res);
              this.$message.error("图片识别失败！");
              return reject(res);
            }
            resolve(res.data.words_result);
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("图片识别失败！");
            reject(err);
          })
          .finally(() => loading.close());
      });
    },
    post() {
      // 企业用户提交
      if (this.userType == "1") {
        this.$refs["params"].validate((valid) => {
          if (valid) {
            this.$refs["bankCardInfoRef"].validate((valid) => {
              if (valid) {
                // 是否已仔细检查信息
                if (!this.checkEnterpriseFlag) {
                  this.$confirm(
                    "为了顺利的提现，请您再从头检查一遍信息",
                    "温馨提示",
                    {
                      confirmButtonText: "确定",
                      showCancelButton: false,
                      closeOnPressEscape: false,
                      closeOnClickModal: false,
                      showClose: false,
                      center: true,
                      customClass: "w_dialog_confirm",
                      type: "warning",
                    }
                  ).then(() => {
                    // 回到页面顶部
                    this.checkEnterpriseFlag = true;
                    document.querySelector(
                      ".w_dialog .el-dialog"
                    ).scrollTop = 0;
                  });
                  return;
                }
                // 0对公
                this.bankCardInfo.cardType = "0";
                this.params = { ...this.params, ...this.bankCardInfo };
                this.params.imgList = [
                  {
                    fileType: "F07",
                    file: this.params.businessLicense,
                  },
                  {
                    fileType: "F02",
                    file: this.params.corporateFrontDocument,
                  },
                  {
                    fileType: "F03",
                    file: this.params.corporateBackDocument,
                  },
                ];
                // this.params.businessLicense = "";
                // this.params.corporateFrontDocument = "";
                // this.params.corporateBackDocument = "";
                console.log(this.params);
                const loading = this.$loading({
                  lock: true,
                  text: "加载中",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)",
                });
                agentFillEnterPriseInfo({
                  ...this.params,
                  businessLicense: "",
                  corporateFrontDocument: "",
                  corporateBackDocument: "",
                })
                  .then((res) => {
                    console.log(res);
                    this.resEditNoDialog({ res });
                  })
                  .finally(() => {
                    loading.close();
                  });
              } else {
                this.$message.error("请先填写完结算卡信息");
              }
            });
          } else {
            this.$message.error("请先填写完企业用户信息");
          }
        });
      } else {
        // 个人用户
        this.$refs["paramsPerson"].validate((valid) => {
          if (valid) {
            this.$refs["bankCardInfoRef"].validate((valid) => {
              if (valid) {
                // 是否已仔细检查信息
                if (!this.checkPersonFlag) {
                  this.$confirm(
                    "为了顺利的提现，请您再从头检查一遍信息",
                    "温馨提示",
                    {
                      confirmButtonText: "确定",
                      showCancelButton: false,
                      closeOnPressEscape: false,
                      closeOnClickModal: false,
                      showClose: false,
                      center: true,
                      customClass: "w_dialog_confirm",
                      type: "warning",
                    }
                  ).then(() => {
                    // 回到页面顶部
                    this.checkPersonFlag = true;
                    document.querySelector(
                      ".w_dialog .el-dialog"
                    ).scrollTop = 0;
                  });
                  return;
                }
                // 1对私
                this.bankCardInfo.cardType = "1";
                this.bankCardInfo.bankCode = "";
                this.bankCardInfo.branchCode = "";
                this.bankCardInfo.cardName = this.paramsPerson.name;
                this.paramsPerson = {
                  ...this.paramsPerson,
                  ...this.bankCardInfo,
                };
                this.paramsPerson.imgList = [
                  {
                    fileType: "F40",
                    file: this.paramsPerson.personalFrontDocument,
                  },
                  {
                    fileType: "F41",
                    file: this.paramsPerson.personalBackDocument,
                  },
                ];
                // this.paramsPerson.personalFrontDocument = "";
                // this.paramsPerson.personalBackDocument = "";
                const loading = this.$loading({
                  lock: true,
                  text: "加载中",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)",
                });
                agentFillInInformation({
                  ...this.paramsPerson,
                  personalFrontDocument: "",
                  personalBackDocument: "",
                })
                  .then((res) => {
                    console.log(res);
                    this.resEditNoDialog({ res });
                  })
                  .finally(() => {
                    loading.close();
                  });
              } else {
                this.$message.error("请先填写完结算卡信息");
              }
            });
          } else {
            this.$message.error("请先填写完个人用户信息");
          }
        });
      }
    },
    handleDialogClosed() {
      this.$refs["params"].resetFields();
      this.$refs["paramsPerson"].resetFields();
      this.$refs["bankCardInfoRef"].resetFields();
      this.checkEnterpriseFlag = false;
      this.checkPersonFlag = false;
    },
  },
};
</script>

<style>
.w_dialog_confirm {
  width: 90%;
}
</style>

<style lang="scss" scoped>
.withdraw_type {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.withdraw_tip {
  font-weight: bold;
  color: red;
}

.car_upload_img {
  width: 140px;
  height: 140px;
  border-radius: 6px;
}

.car_uploader_icon {
  width: 140px;
  height: 140px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #ccc;

  i {
    font-size: 30px;
  }

  &:hover {
    border-color: #66b1ff;
  }
}

/deep/ .el-select-dropdown__list {
  text-align: right !important;
}

/deep/ .el-date-editor.el-input {
  width: 100%;
}
</style>
